export const styles = {
  layoutWrapper: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '93.1vh',
  },
};
